// Tiempo máximo de espera para el servicio externo de seguros
export const TIMEOUT_MS = 8000;

const seguroTercero = {
  namespaced: true,
  state: () => ({
    // usernameOrEmail: "leoncyapp@holdingvml.net",
    // password: "$leoncyapp2022*",
    Username: "leoncyapp",
    Password: "WSL30ncy4pp",
    ClientId: 1021,
    // api: "https://appstool.co/bank-insurance-third/api",
    api: "https://appstool.co:8081/WebApiTrans/api",
    tokenSeguroTerceros: "",
  }),
  mutations: {
    SetTokenSeguroTerceros(state, payload) {
      state.tokenSeguroTerceros = payload;
    },
  },
  actions: {
    // Nunca lanza error ni muestra alertas bloqueantes: si el servicio falla
    // devuelve "" y el caso se puede crear con tipo_plan "SIN PLAN".
    async AuthSeguroTercero({ commit, getters }) {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Accept", "application/json");

      const body = JSON.stringify({
        Username: getters.getUsernameOrEmail,
        Password: getters.getPassword,
        ClientId: getters.getClientId,
      });

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), TIMEOUT_MS);

      try {
        const response = await fetch(`${getters.getApi}/gettoken`, {
          method: "POST",
          headers,
          body,
          redirect: "follow",
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const result = await response.json();
        commit("SetTokenSeguroTerceros", result || "");
        return result || "";
      } catch (error) {
        console.warn("Servicio de confirmación de plan no disponible:", error);
        commit("SetTokenSeguroTerceros", "");
        return "";
      } finally {
        clearTimeout(timeout);
      }
    },
  },
  getters: {
    getUsernameOrEmail(state) {
      return state.Username;
    },
    getPassword(state) {
      return state.Password;
    },
    getClientId(state) {
      return state.ClientId;
    },
    getApi(state) {
      return state.api;
    },
    getTokenSeguroTerceros(state) {
      return state.tokenSeguroTerceros;
    },
  },
};

export default seguroTercero;
